import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { WfService } from 'src/app/service/wf';
import { ProcessoCadastroRevisaoClienteFornecedorLista, ProcessoCadastroRevisaoClienteFornecedorListaItem } from '../../interface/processo-revisao-cadastro-cliente-fornecedor';
import { ProcessoCadastroService } from '../../service/processo-cadastro';
import { FiltroListaProcessoRevisaoClienteFornecedor } from '../../service/filtro/filtro-lista-processo-cadastro';
import { UsuarioBase } from 'src/app/interface/usuario';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';

@Component({
  selector: 'app-revisao-cadastro-lista',
  templateUrl: './revisao-cadastro-lista.component.html',
  styleUrls: ['./revisao-cadastro-lista.component.css']
})
export class RevisaoCadastroListaComponent implements OnInit {

  statusList: any[] = [];
  tipoList: any[] = [];
  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroListaProcessoRevisaoClienteFornecedor;


  usuarioAdvancedFilters: Array<PoDynamicFormField>;
  usuarioColumnsFilters: Array<PoLookupColumn>;
  usuarioFieldFormaterFilters: ((value: UsuarioBase) => string);

  constructor(
    public router: Router,
    private processoCadastroService: ProcessoCadastroService,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private wfService: WfService,
    public usuarioLookupService: UsuarioLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaProcessoRevisaoClienteFornecedor(poStorageService,'revisao-cadastro-lista');

    this.usuarioAdvancedFilters      = this.usuarioLookupService.getAdvancedFilter();
    this.usuarioColumnsFilters       = this.usuarioLookupService.getColumnsFilter();
    this.usuarioFieldFormaterFilters = this.usuarioLookupService.getFieldFormater;

  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Processo Cadastro'},
    ],
  };

  ngOnInit(): void {
    this.statusList = [
      {value: ' ', label: 'Todos'},
      {value: 'P', label: 'Pendente'},
      {value: 'C', label: 'Confirmado'},
      {value: 'F', label: 'Finalizado'},
    ];
    this.tipoList = [
      {value: 'K,W', label: 'Todos'},
      {value: 'K', label: 'Cliente'},
      {value: 'W', label: 'Fornecedor'},
    ];

    this.tabelaPrincipalLoad();
  }

  aprovar(row: ProcessoCadastroRevisaoClienteFornecedorListaItem): void {
    if (row.CTIPO == "K"){
      this.router.navigateByUrl(`/administrativo/revisao-cadastro/cliente/aprovar/${row.NCODIGO}`);
    }else if (row.CTIPO == "W"){
      this.router.navigateByUrl(`/administrativo/revisao-cadastro/fornecedor/aprovar/${row.NCODIGO}`);
    }
  }

  enviarEmaildisabled(row: ProcessoCadastroRevisaoClienteFornecedorListaItem): boolean{
    if (row.CSTATUS != "P"){
      return true;
    }
    return false;
  }

  enviarEmail(row: ProcessoCadastroRevisaoClienteFornecedorListaItem): void {

    this.poDialogService.confirm({
      title: 'Enviar email',
      message: 'Deseja realmente enviar o email novamente?',
      confirm: () => this.wfService.postAtualizacaoCadastroEnviaEmail(row.CTIPO,row.NCODIGO).subscribe(),
    });
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  tabelaPrincipalLoad(){

    this.tabelaPrincipalFiltro.setStorage();

    this.tabelaPrincipalItens = [];
    this.processoCadastroService.getProcCadastroRevisaoClienteFornecedorLista(this.tabelaPrincipalFiltro.dados).subscribe(lista => {
      if (lista) {

        this.tabelaPrincipalItens = lista.items.map( item => {
          return {...item, favorite: ['aprovar','email']};
        });
      }
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {
      property: 'CSTATUS',
      type: 'subtitle',
      width: '7%',
      label: 'Status',
      visible: true,
      subtitles: [
        {value: 'P', color: 'color-01', content: 'P', label: 'Pendente'},
        {value: 'C', color: 'color-10', content: 'C', label: 'Confirmado'},
        {value: 'F', color: 'color-07', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'NCODIGO', width: '5%', visible: true, label: 'Processo'},
    {
      property: 'CTIPO',
      type: 'label',
      width: '7%',
      label: 'Tipo Processo',
      visible: true,
      labels: [
        {value: 'K', color: 'color-03', label: 'Cliente'},
        {value: 'W', color: 'color-06', label: 'Fornecedor'},
      ]
    },
    {property: 'CCODIGOPROTHEUS', width: '7%' , visible: true, label: 'Código'},
    {property: 'CLOJA'          , width: '5%' , visible: true, label: 'Loja'},
    {property: 'CCGC'           , width: '20%', visible: true, label: 'CPF/CNPJ'},
    {property: 'CRAZAOSOCIAL'   , width: '20%', visible: true, label: 'Razão Social'},
    {property: 'CNOMEFANTASIA'  , width: '20%', visible: true, label: 'Fantasia'},
    {property: 'DINCLUSAO'      , width: '7%' , visible: true, label: 'Inclusão'      , type: 'date'},
    {property: 'DFINALIZACAO'   , width: '7%' , visible: true, label: 'Finalizado'    , type: 'date'},

    {
      property: 'favorite',
      label: '...',
      type: 'icon',
      width: '8%',
      icons: [
        {
          action: this.aprovar.bind(this),
          icon: 'po-icon-eye',
          tooltip: 'Aprovar',
          value: 'aprovar',
        },
        {
          action: this.enviarEmail.bind(this),
          icon: 'po-icon-mail',
          tooltip: 'Enviar Email',
          value: 'email',
          disabled: this.enviarEmaildisabled.bind(this)
        },
      ]
    },
  ];

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };
}
